import React, { useState, useEffect, useRef } from 'react';

export const ParticleSystem = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const particlesRef = useRef([]);

  class Particle {
    constructor(x, y) {
      this.x = x;
      this.y = y;
      this.vx = (Math.random() - 0.5) * 0.5;
      this.vy = -Math.random() * 2 - 1;
      this.life = 1.0;
      this.decay = Math.random() * 0.015 + 0.01;
      this.size = Math.random() * 15 + 10;
    }

    update() {
      this.x += this.vx;
      this.y += this.vy;
      this.life -= this.decay;
      this.vx *= 0.98;
      this.vy *= 0.98;
      this.size *= 0.98;
    }

    draw(ctx) {
      const gradient = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size);
      const alpha = this.life;
      
      if (this.life > 0.5) {
        gradient.addColorStop(0, `rgba(255, 255, 200, ${alpha})`);
        gradient.addColorStop(0.3, `rgba(255, 200, 0, ${alpha * 0.8})`);
        gradient.addColorStop(0.6, `rgba(255, 100, 0, ${alpha * 0.5})`);
        gradient.addColorStop(1, `rgba(255, 50, 0, 0)`);
      } else {
        gradient.addColorStop(0, `rgba(255, 100, 0, ${alpha})`);
        gradient.addColorStop(0.5, `rgba(200, 50, 0, ${alpha * 0.5})`);
        gradient.addColorStop(1, `rgba(100, 0, 0, 0)`);
      }
      
      ctx.fillStyle = gradient;
      ctx.fillRect(this.x - this.size, this.y - this.size, this.size * 2, this.size * 2);
    }
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = 400;
    canvas.height = 400;

    const animate = () => {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      for (let i = 0; i < 3; i++) {
        particlesRef.current.push(new Particle(
          canvas.width / 2 + (Math.random() - 0.5) * 20,
          canvas.height - 50
        ));
      }
      
      particlesRef.current = particlesRef.current.filter(particle => particle.life > 0);
      
      ctx.globalCompositeOperation = 'lighter';
      particlesRef.current.forEach(particle => {
        particle.update();
        particle.draw(ctx);
      });
      ctx.globalCompositeOperation = 'source-over';
      
      animationRef.current = requestAnimationFrame(animate);
    };
    
    animate();
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-900">
      <canvas ref={canvasRef} className="border border-gray-700 rounded-lg" />
      <div className="mt-4 text-white text-center">
        <h3 className="text-xl font-bold">Particle System</h3>
        <p className="text-gray-400">Canvas 2D with particle simulation</p>
      </div>
    </div>
  );
};
